import CreateFormatTemplate from "@/formatTemplate/components/CreateFormatTemplate";
import { FormatTemplateSidePanel } from "./components/FormatTemplateSidePanel";
import { FormatTemplateSearch } from "@/formatTemplate/components/FormatTemplateSearch";
import { useFormatTemplateStore } from "@/state/formatTemplateStore";
import FormatEdit from "@/formatTemplate/components/FormatEdit";

export default function FormatTemplate() {
  const { formatTemplateSidebar } = useFormatTemplateStore();
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        gap: "1rem",
        minHeight: "100vh",
      }}
    >
      <FormatTemplateSidePanel />
      <div
        style={{
          width: "80%",
          marginLeft: "auto",
        }}
      >
        {formatTemplateSidebar === "search-existing" && <FormatTemplateSearch />}
        {formatTemplateSidebar === "create-new" && <CreateFormatTemplate />}
        {formatTemplateSidebar === "update" && <FormatEdit />}
      </div>
    </div>
  );
}
